// Must be imported BEFORE lazysizes itself: ES module imports are evaluated
// before the importing module's body, so setting this in site.js would run
// after lazysizes had already read its config.
window.lazySizesConfig = window.lazySizesConfig || {}

// How far outside the viewport (px) to start loading. lazysizes defaults to
// ~370, which starts the fetch only once an image is nearly in view.
window.lazySizesConfig.expand = 700
